import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { I18nModule, RoutingModule, UrlModule } from '@spartacus/core';
import { FormErrorsModule, MediaModule } from '@spartacus/storefront';

import { KnBrDirectiveModule } from 'src/shared/directive/kn-br-directive.module';
import { KnBrMyQuoteItemComponent } from './kn-br-my-quote-item.component';

@NgModule({
  declarations: [KnBrMyQuoteItemComponent],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    RoutingModule,
    I18nModule,
    MediaModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    KnBrDirectiveModule,
    FormErrorsModule,
  ],
  exports: [KnBrMyQuoteItemComponent],
})
export class KnBrMyQuoteItemModule {}
